import { render, staticRenderFns } from "./corporate-development.vue?vue&type=template&id=2719ed1e"
import script from "./corporate-development.vue?vue&type=script&lang=js"
export * from "./corporate-development.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports